import type { ConnectWizardEvents } from './enum.support-wizard';
import { ConnectWizardEvent } from './enum.support-wizard';
import type {
  TransactionInputEvent,
  ConnectToSupportEvent,
  VisitorInfoSubmittedEvent,
  DescriptionSubmittedEvent,
  OpenRequestSelectedEvent,
  ConfirmConnectSupportRequestEvent,
} from './events.support-wizard.types';

function createEventIdentifier<K>(type: ConnectWizardEvents) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (event: any): event is K => event?.type === type;
}
export const isTransactionInputEvent = createEventIdentifier<TransactionInputEvent>(
  ConnectWizardEvent.transactionSelected
);
export const isConnectToSupportEvent = createEventIdentifier<ConnectToSupportEvent>(ConnectWizardEvent.connectRequest);
export const isConfirmConnectSupportRequestEvent = createEventIdentifier<ConfirmConnectSupportRequestEvent>(
  ConnectWizardEvent.confirmConnectSupportRequest
);
export const isVisitorInfoSubmittedEvent = createEventIdentifier<VisitorInfoSubmittedEvent>(
  ConnectWizardEvent.guestInfoFilled
);
export const isDescriptionSubmittedEvent = createEventIdentifier<DescriptionSubmittedEvent>(
  ConnectWizardEvent.descriptionSubmitted
);
export const isOpenRequestSelectedEvent = createEventIdentifier<OpenRequestSelectedEvent>(
  ConnectWizardEvent.openRequestSelected
);

interface CreateEvent {
  (evt: TransactionInputEvent): TransactionInputEvent;
  (evt: ConnectToSupportEvent): ConnectToSupportEvent;
  (evt: VisitorInfoSubmittedEvent): VisitorInfoSubmittedEvent;
  (evt: DescriptionSubmittedEvent): DescriptionSubmittedEvent;
}

export const createWizardEvent = ((evt) => ({ ...evt })) as CreateEvent;
